import gqlRequest from 'graphql/generic';
import { Notifications } from '../types';

type GetNotifications = {
  getNotifications: Notifications[];
};

const query = `
  query GetNotifications {
    getNotifications {
      _id
      subject
      html
      prompt
    }
  }
`;

export const getNotifications = () => gqlRequest<GetNotifications>(query);
